import { render, staticRenderFns } from "./consumer-details.vue?vue&type=template&id=4faab91e&scoped=true"
import script from "./consumer-details.vue?vue&type=script&lang=js"
export * from "./consumer-details.vue?vue&type=script&lang=js"
import style0 from "./consumer-details.vue?vue&type=style&index=0&id=4faab91e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faab91e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4faab91e')) {
      api.createRecord('4faab91e', component.options)
    } else {
      api.reload('4faab91e', component.options)
    }
    module.hot.accept("./consumer-details.vue?vue&type=template&id=4faab91e&scoped=true", function () {
      api.rerender('4faab91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/participant/consumer/form/component/consumer-details.vue"
export default component.exports